import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Timeline, Title } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { SettingsService } from 'src/app/shared/services/settings.service';

@Component({
  selector: 'app-timeline-crud',
  templateUrl: './timeline-crud.component.html',
  styleUrls: ['./timeline-crud.component.scss'],
})
export class TimelineCrudComponent implements OnInit {
  @Input() desigination: Timeline;
  @Input() context: Context;
  @Input() desiginations: Timeline[] = [];
  public titles: Title[] = [];
  public desiginationForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private settingsService: SettingsService,
    private datePipe: DatePipe,

  ) { }

  ngOnInit(): void {
    this.setDesiginationForm(this.desigination);
    if (this.context.companyId) {
      this.settingsService.getTitles(this.context.companyId, null, null, false).subscribe((titles) => (this.titles = titles));
    }
  }

  public setDesiginationForm(desigination?: Timeline) {
    if (!desigination)
      desigination = {
        id: null,
        start:this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        end: null,
        label: null,
        active: false,
        disabled: false,
        employeeData: { id: this.context?.employeeId },
        title: { id: null } as Title,
      } as Timeline;
    this.desiginationForm = this.fb.group({
      id: this.fb.control(desigination?.id),
      start: this.fb.control(desigination.start, [Validators.required]),
      end: this.fb.control(desigination.end, []),
      label: this.fb.control(desigination.label, []),
      disabled: this.fb.control(desigination.disabled, []),
      active: this.fb.control(desigination.active, []),
      title: this.fb.group({
        id: this.fb.control(desigination?.title?.id, [Validators.required]),
        name: this.fb.control(desigination?.title?.name, []),
      }),
      employeeData: this.fb.group({
        id: this.fb.control(desigination?.employeeData?.id, [Validators.required
          ,
        ]),
      }),
    });
    this.desiginationForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.desiginationForm.controls;
  }

  get g() {
    return this.f.title as FormGroup;
  }
  public saveDesigination(inProgress?: any) {
    this.submitted = true;
    if (this.desiginationForm.valid) {
      const desigination = this.desiginationForm.value as Timeline;
      if (this.desiginations.some(t => t?.title?.id === desigination?.title?.id)) {
        this.commonService.setToastr(400, `Cannot ${desigination?.id ? 'update' : 'add'} the record. ${desigination?.title.name} already exists.`);
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Desigination ${desigination?.title?.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (desigination.id) {
        this.employeeService.updateTimeline(desigination.id, desigination).subscribe({
          next: (response: Timeline) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Desigination ${response?.title?.name} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            // this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.employeeService.createTimeline(desigination).subscribe({
          next: (response: Timeline) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Desigination ${response?.title?.name} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
